import { NativeModules, Platform} from 'react-native';

const CalendarLocale = {
    en: {
        amDesignator: 'AM',
        dayNames: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
        ],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        monthNames: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ],
        monthNamesShort: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
        ],
        pmDesignator: 'PM',
    },
    gr: {
        amDesignator: 'π.μ.',
        dayNames: [
            'Κυριακή',
            'Δευτέρα',
            'Τρίτη',
            'Τετάρτη',
            'Πέμπτη',
            'Παρασκευή',
            'Σάββατο',
        ],
        dayNamesShort: ['Κυρ', 'Δευ', 'Τρ', 'Τετ', 'Πέμ', 'Παρ', 'Σάβ'],
        monthNames: [
            'Ιανουάριος',
            'Φεβρουάριος',
            'Μάρτιος',
            'Απρίλιος',
            'Μάιος',
            'Ιούνιος',
            'Ιούλιος',
            'Αύγουστος',
            'Σεπτέμβριος',
            'Οκτώβριος',
            'Νοέμβριος',
            'Δεκέμβριος',
        ],
        monthNamesShort: [
            'Ιαν',
            'Φεβ',
            'Μάρ',
            'Απρ',
            'Μάι',
            'Ιούν',
            'Ιούλ',
            'Αύγ',
            'Σεπ',
            'Οκτ',
            'Νοέ',
            'Δεκ',
        ],
        pmDesignator: 'μ.μ.',
    },
};

function getLocale(selectedLanguage) {
    if (selectedLanguage === 'en') {
        // set calendar locale to en
        return 'en';
    }
    else if (selectedLanguage === 'gr') {
        // set calendar locale to gr
        return 'gr';
    };
};

function getMondayFirst() {
    // locale is the device's locale
    var locale;
    if(  Platform.OS === 'ios')
        locale =  NativeModules.SettingsManager.settings.AppleLanguages[0] ||
            NativeModules.SettingsManager.settings.AppleLocale
    else if ( Platform.OS === 'android')
        locale = NativeModules.I18nManager.localeIdentifier
    else 
        locale = 'en'

    locale = locale.replace("-", "_"); // ios has '-' instead of '_', so normalize

    var localeCountry = locale.substring(3);

    if (localeCountry === 'US' || localeCountry === 'CA' || localeCountry === 'AR' || localeCountry === 'BR' || localeCountry === 'CO' ||
        localeCountry === 'ZA' || localeCountry === 'NG' || localeCountry === 'EG' || localeCountry === 'IN' || localeCountry === 'PK' ||
        localeCountry === 'ID' || localeCountry === 'BD' || localeCountry === 'JP' || localeCountry === 'KR' || localeCountry === 'IL' ||
        localeCountry === 'SA' || localeCountry === 'AE') {
        // sunday first
        return 0;
    }
    else {
        // monday first
        return 1;
    };
};

export { CalendarLocale, getLocale, getMondayFirst };